export default "__VITE_ASSET__B_Mzq0i4__"